<template>
<div class="chapter">
<div class="inner_page">
<p class="center1"><a id="page_2"></a>TOR BOOKS BY THOMAS HARLAN</p>
<p class="center2">IN THE TIME OF THE SIXTH SUN</p>
<p class="center3">WASTELAND OF FLINT</p>
<p class="center3a">HOUSE OF REEDS</p>
<p class="center4">OATH OF EMPIRE</p>
<p class="center4a">THE SHADOW OF ARARAT</p>
<p class="center4b">THE GATE OF FIRE</p>
<p class="center4c">THE STORM OF HEAVEN</p>
<p class="center4d">THE DARK LORD</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter001.vue?476d7936